import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * Reusable advanced page shell — professional blue hero + panel.
 */
export function BrixPageShell({ children, className = "" }) {
  return <div className={`brix-page ${className}`.trim()}>{children}</div>;
}

export function BrixPageHero({
  icon: Icon,
  eyebrow,
  title,
  subtitle,
  actions,
  backTo,
  backLabel = "Back",
  children,
  className = "",
}) {
  return (
    <header className={`brix-hero ${className}`.trim()}>
      {backTo ? (
        <Link to={backTo} className="brix-hero-back">
          <ArrowLeft size={16} strokeWidth={2} aria-hidden />
          {backLabel}
        </Link>
      ) : null}
      <div className="brix-hero-row">
        <div className="brix-hero-main">
          {Icon ? (
            <div className="brix-hero-icon" aria-hidden>
              <Icon size={20} strokeWidth={1.75} />
            </div>
          ) : null}
          <div className="min-w-0">
            {eyebrow ? <div className="brix-hero-eyebrow">{eyebrow}</div> : null}
            <h1 className="brix-hero-title">{title}</h1>
            {subtitle ? <p className="brix-hero-sub">{subtitle}</p> : null}
          </div>
        </div>
        {actions ? <div className="brix-hero-actions">{actions}</div> : null}
      </div>
      {children}
    </header>
  );
}

export function BrixPanel({
  title,
  subtitle,
  headerRight,
  children,
  className = "",
  bodyClassName = "",
  noPadding = false,
}) {
  return (
    <section className={`brix-panel ${className}`.trim()}>
      {(title || subtitle || headerRight) && (
        <div className="brix-panel-head">
          <div>
            {title ? <h2 className="brix-panel-title">{title}</h2> : null}
            {subtitle ? <p className="brix-panel-sub">{subtitle}</p> : null}
          </div>
          {headerRight}
        </div>
      )}
      <div className={noPadding ? bodyClassName : `brix-panel-body ${bodyClassName}`.trim()}>
        {children}
      </div>
    </section>
  );
}

export function BrixBtn({
  children,
  variant = "primary",
  className = "",
  type = "button",
  ...props
}) {
  const variants = {
    primary: "brix-btn brix-btn--primary",
    secondary: "brix-btn brix-btn--secondary",
    ghost: "brix-btn brix-btn--ghost",
  };
  return (
    <button
      type={type}
      className={`${variants[variant] || variants.primary} ${className}`.trim()}
      {...props}
    >
      {children}
    </button>
  );
}
